import DeliveryLeadTime from 'pages/BackOfficePage/BackOfficeCategories/DeliveryLeadTime/DeliveryLeadTime';

export default DeliveryLeadTime;
